var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopContentUnitList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#CCCDD3",
    fillOpacity: 0.62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1221_3552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4898 7.18491V5.19169C13.4898 5.16119 13.4898 5.12051 13.4797 5.09C13.4593 4.94763 13.3881 4.80525 13.2864 4.70356C13.1746 4.59169 13.0322 4.52051 12.8695 4.52051C12.839 4.52051 12.8186 4.52051 12.7881 4.53068L8.13051 5.23237C7.95763 5.25271 7.80508 5.33407 7.69322 5.44593C7.58136 5.5578 7.51017 5.71034 7.51017 5.89339V7.89678V11.151C7.48983 11.1408 7.47966 11.1307 7.46949 11.1307C7.15424 10.8968 6.72712 10.7544 6.25932 10.7544C5.79153 10.7544 5.36441 10.8968 5.04915 11.1307C4.71356 11.3747 4.5 11.7307 4.5 12.1171C4.5 12.5036 4.70339 12.8595 5.04915 13.1036C5.36441 13.3375 5.79153 13.4798 6.25932 13.4798C6.72712 13.4798 7.15424 13.3375 7.46949 13.1036C7.80508 12.8595 8.01864 12.5036 8.01864 12.1171C8.01864 12.1069 8.01864 12.0866 8.01864 12.0764V8.12051L12.9814 7.47983V10.4493C12.9712 10.4392 12.961 10.4392 12.9508 10.429C12.6356 10.1951 12.2085 10.0527 11.7407 10.0527C11.2729 10.0527 10.8458 10.1951 10.5305 10.429C10.1949 10.673 9.98136 11.029 9.98136 11.4154C9.98136 11.8019 10.1847 12.1578 10.5305 12.4019C10.8458 12.6358 11.2729 12.7781 11.7407 12.7781C12.2085 12.7781 12.6356 12.6358 12.9508 12.4019C13.2864 12.1578 13.5 11.8019 13.5 11.4154C13.5 11.4053 13.5 11.3849 13.5 11.3747V7.21542C13.4898 7.20525 13.4898 7.19508 13.4898 7.18491Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1221_3552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(4.5 4.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopContentUnitList);
export default __webpack_public_path__ + "static/media/top_content_unit_list.b0135815c85062cd556b6c4e1bfd74a8.svg";
export { ForwardRef as ReactComponent };